import { useEffect } from 'react'

interface PageMetaOptions {
  title: string
  description?: string
  image?: string
}

const META_SELECTORS = [
  'meta[name="description"]',
  'meta[property="og:title"]',
  'meta[name="twitter:title"]',
  'meta[property="og:description"]',
  'meta[name="twitter:description"]',
  'meta[property="og:image"]',
  'meta[name="twitter:image"]',
] as const

/** Define título e meta tags (SEO/compartilhamento) enquanto a página está montada, restaurando os valores anteriores ao desmontar. */
export function usePageMeta({ title, description, image }: PageMetaOptions) {
  useEffect(() => {
    const previousTitle = document.title
    document.title = title

    const values: Record<(typeof META_SELECTORS)[number], string | undefined> = {
      'meta[name="description"]': description,
      'meta[property="og:title"]': title,
      'meta[name="twitter:title"]': title,
      'meta[property="og:description"]': description,
      'meta[name="twitter:description"]': description,
      'meta[property="og:image"]': image,
      'meta[name="twitter:image"]': image,
    }

    const previousValues = META_SELECTORS.map(
      (selector) => document.querySelector<HTMLMetaElement>(selector)?.getAttribute('content') ?? null,
    )

    META_SELECTORS.forEach((selector) => {
      const value = values[selector]
      if (!value) return
      document.querySelector<HTMLMetaElement>(selector)?.setAttribute('content', value)
    })

    return () => {
      document.title = previousTitle
      META_SELECTORS.forEach((selector, i) => {
        const previous = previousValues[i]
        if (previous !== null) {
          document.querySelector<HTMLMetaElement>(selector)?.setAttribute('content', previous)
        }
      })
    }
  }, [title, description, image])
}
